/**
 * Display rules of the escalator specification and TZB in LM4 (HCIT-937). Pure functions without Core, so they can
 * be tested without the app bootstrap.
 */

/** Driving direction texts as the SmartLift app writes them into the specification (HCIT-934). */
export const DIRECTIONS = [ "aufwärts", "abwärts" ];

const DIRECTION_TEXT = {
    UP  : "aufwärts",
    DOWN: "abwärts",
};

/** Lighting switches of the specification and their labels (i18n keys below unit.escalator.lighting). */
export const LIGHTING = [
    { property: "lightingStepBand", key: "stepBand" },
    { property: "lightingBalustrade", key: "balustrade" },
    { property: "lightingCombCarrier", key: "combCarrier" },
    { property: "lightingStepGap", key: "stepGap" },
    { property: "lightingOther", key: "other" },
];

const escape = function (text) {
    return text
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll("\"", "&quot;")
        .replaceAll("'", "&#39;");
};

export default {
    directions: DIRECTIONS,
    lighting  : LIGHTING,

    /**
     * A note as HTML: notes come from the app and the LM4, so they are escaped; line breaks (also the literal "\n" of
     * older generated texts) are kept.
     */
    noteHtml (note) {
        if (!note) {
            return "";
        }

        return escape(String(note)).replaceAll("\\n", "<br>").replaceAll("\n", "<br>");
    },

    /** The driving direction as text: UP/DOWN of the disposition data are translated, texts are kept. */
    directionText (direction) {
        if (!direction) {
            return null;
        }

        return DIRECTION_TEXT[String(direction).toUpperCase()] || direction;
    },

    /**
     * The switched-on lighting as list of labels; "other" is shown with its text.
     *
     * @param data the specification (lightingStepBand …) or the disposition lighting ({ stepBand … })
     * @param label function key → label
     */
    lightingText (data, label) {
        if (!data) {
            return [];
        }

        return LIGHTING
            .filter(item => data[item.property] || data[item.key])
            .map(item => {
                const otherText = data.lightingOtherText || data.otherText;
                return item.key === "other" && otherText ? label(item.key) + ": " + otherText : label(item.key);
            });
    },

    /**
     * Whether the TZB is the latest of the site; only its notes can be changed (masterdata-svc answers 409 otherwise).
     */
    isLatest (history, tzbId) {
        if (!history || history.length === 0 || !tzbId) {
            return false;
        }

        return Math.max(...history.map(item => item.id)) === tzbId;
    },

    /**
     * A number in German format ("4,5"); text that is not a number (e.g. a gradient typed as text) is kept.
     */
    numberText (value) {
        if (value === null || value === undefined || value === "") {
            return null;
        }

        const number = typeof value === "number" ? value : Number(value);
        return Number.isFinite(number) ? number.toLocaleString("de-DE", { maximumFractionDigits: 3 }) : String(value);
    },
}
